import { generateUUID, isEmpty } from 'mc-ui-utils';
import State from '../state';
import { getStartSource } from '../utils/khazaddumbridge';
import BaseEvent from './BaseEvent';
import highlightEvent, { SessionMode } from './HighlightEvent';
export default class BubbleEvent extends BaseEvent {
    constructor(bubbleId, position, count) {
        super();
        this.highlightsSessionId = highlightEvent.highlightsSessionId;
        this.glanceStartedCount = 0;
        this.unseenGlanceCount = 0;
        this.startSource = '';
        this.endSource = '';
        this.bubbleMode = SessionMode.HIGHLIGHTS;
        this.eventName = "bubble_event" /* BUBBLE */;
        this.bubbleId = bubbleId;
        this.bubblePosition = position;
        this.totalGlanceCount = count;
        if (position === 0) {
            this.startSource = getStartSource() || '';
        }
    }
    setShown(source, startGlanceId, seenCount) {
        this.reset();
        this.startTime = Date.now();
        this.bubbleImpressionId = generateUUID();
        if (!isEmpty(source)) {
            this.startSource = source;
        }
        else {
            if (!isEmpty(State.lastPageChangeSource)) {
                this.startSource = State.lastPageChangeSource;
            }
            else {
                this.startSource = getStartSource();
            }
        }
        this.startGlance = startGlanceId;
        if (seenCount) {
            this.glanceStartedCount = seenCount;
        }
    }
    reset() {
        this.glanceStartedCount = 0;
        this.peekStartedCount = 0;
    }
    setGlanceSeen() {
        this.glanceStartedCount += 1;
    }
    setGlanceInteracted() {
        this.peekStartedCount += 1;
    }
    setFinished(source, endGlanceId) {
        this.endSource = source;
        this.endGlance = endGlanceId;
        this.endTime = Date.now();
        this.unseenGlanceCount = this.totalGlanceCount - this.glanceStartedCount;
        this.duration = this.endTime - this.startTime;
    }
}
//# sourceMappingURL=BubbleEvent.js.map